/**
 * PATH: apps/qa/src/pages/record-detail/useQaRecordDataAdapter.ts
 * FILE_ID: QA-RECORD-DATA-ADAPTER-001
 * PURPOSE: Django job-hub client for a QA record page.
 */
import { useMemo } from 'react'
import { getConfiguredClient } from '@quotech/api'
import { useAuthStore } from '@quotech/auth'
import { createDjangoJobHubClient } from '@quotech/job-hub/jobs/djangoJobHubClient'

export function useQaRecordDataAdapter() {
  const orgId = useAuthStore((state) => state.organisationId)
  const numericOrgId = orgId != null ? Number(orgId) : undefined
  const dataAdapter = useMemo(
    () => ({
      client: createDjangoJobHubClient(getConfiguredClient(), { orgId: numericOrgId }),
      capabilities: {
        schedulePage: false,
        invoiceExtraction: false,
        jobTeamAccess: true,
        documentGeneration: false,
        excelExport: false,
        moneyLedger: false,
      },
    }),
    [numericOrgId],
  )
  return { dataAdapter, numericOrgId }
}
